import { useTranslations } from 'next-intl';
import { buildRoute, DataTestConfig } from '@headless-workspace/config';
import { UIBrandoramaContainer } from '@headless-workspace/core-ui';
import { DataLayerClassName } from '@headless-workspace/domain/common/client';
import { PropsWithClassName, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { HomeBrandoramaValue } from '../../../../../src';

type HomeBrandoramaSectionProps = PropsWithLocale &
    PropsWithClassName & {
        brandorama: HomeBrandoramaValue;
    };

const DATA_LAYER_ID = 'cta_voir_plus';
export const HomeBrandoramaSection: Component<HomeBrandoramaSectionProps> = ({ brandorama, locale, className }) => {
    const t = useTranslations('Discover.Home');

    return (
        <UIBrandoramaContainer
            title={t('brandorama.title')}
            subtitle={t('brandorama.subtitle')}
            button={{
                href: buildRoute(locale, 'allBrands'),
                label: t('brandorama.seeAll'),
            }}
            brandoramaTiles={brandorama.tiles}
            dataLayer={{
                id: DATA_LAYER_ID,
                className: DataLayerClassName.brandorama,
            }}
            className={className}
            dataTestId={`${DataTestConfig.testIds.homeSlotSection}${brandorama.type}`}
        />
    );
};
